// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"271edbdfbd759bd5","684":"8ea7f696f2427944","8374":"88ad0113e3f3db63","9777":"4c150b3db8a3a3a3"}[chunkId] + ".js";
};